import { NUDGES_WIDGET_NAMES } from "@/constants/widget-names";
import RewardsStorefrontValuesService from "@apps/rewards/modules/StorefrontValues/service/RewardsStorefrontValuesService";
import RewardsPopUpWidgetLauncherManager from "@apps/rewards/widgets/rewards_popup_widget/utils/RewardsPopUpWidgetLauncherManager/RewardsPopUpWidgetLauncherManager";
import CustomizationManager from "@lib/CustomizationManager/CustomizationManager";
import { BaseModule } from "@modules/base_module/BaseModule";
import { container, injectable } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";
import type { WidgetInterface } from "@interfaces/WidgetInterface";

import { getNudgesContext } from "../nudgesContext";
import NudgesWidgetComponent from "./NudgesWidget.svelte";
import { NudgesWidgetConfigInterface } from "./NudgesWidgetConfig";

@injectable()
class NudgesWidget implements WidgetInterface {
    constructor(
        private readonly config: NudgesWidgetConfigInterface,
        private readonly logger: LoggerInterface
    ) {
        this.logger.debug("NudgesWidget is initialized", config);
    }

    async init(): Promise<this> {
        const rewardsPopUpWidgetLauncherManager = container.resolve(
            RewardsPopUpWidgetLauncherManager
        );
        const rewardsStorefrontValuesService = container.resolve(
            RewardsStorefrontValuesService
        );
        const modulesStatusesProvider =
            container.resolve(BaseModule).exports.modulesStatusesProvider;

        const customizationManager = container.resolve(CustomizationManager);

        const element = this.config.target;

        let placeholder = element.querySelector<HTMLElement>(
            ".gw-nudges-popup-widget-placeholder"
        );

        if (!placeholder) {
            placeholder = document.createElement("div");
            placeholder.classList.add("gw-nudges-popup-widget-placeholder");
            placeholder.style.display = "block";
            element.appendChild(placeholder);
        }

        //shadowRoot
        const shadowRoot =
            placeholder.shadowRoot ||
            placeholder.attachShadow({ mode: "open" });

        const customizationManagerConfig = {
            widgetName: NUDGES_WIDGET_NAMES.NUDGES_WIDGET,
            placeholder,
            shadowRoot,
        };
        customizationManager.injectStylesFromCustomization(
            customizationManagerConfig
        );

        await customizationManager.beforeWidgetInject(
            customizationManagerConfig
        );

        new NudgesWidgetComponent({
            target: shadowRoot,
            props: {
                rewardsPopUpWidgetLauncherManager,
                rewardsStorefrontValuesService,
                modulesStatusesProvider,
                logger: this.logger,
            },
            context: getNudgesContext(),
        });

        customizationManager.afterWidgetInject(customizationManagerConfig);

        return this;
    }
}

export default NudgesWidget;
